import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { AuthContext } from '../../components/AuthContext';
const Estimate = () => {
  const { user } = useContext(AuthContext);
  const [estimates, setEstimates] = useState([]); 
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({
    name: '',
    items: [{ 
      skuCode: '',
      quantity: 1,
      rate: 0
    }],
    createdBy: user?.user?._id,
  });
  const [ModalVisible, setModalVisible] = useState({ open: false, func: null });
  const [filter, setFilter] = useState(''); 
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const totalPages = Math.ceil(totalItems / limit);

  function handleView(data){
    Swal.fire({
      title: 'View Estimate',
      html: `
          <strong>ID: </strong> ${data.id}<br>
          <strong>Name: </strong> ${data.name}<br>
          <strong>Item Count: </strong> ${data.items.length}<br>
          <strong>Items: </strong><br>
          ${data.items.map((item, idx) => (
                    `<strong>${idx + 1}.</strong> ${item.skuCode} (Qty: ${item.quantity}, Rate: ${item.rate ? item.rate : 0})`
                )).join('<br>')}
          <br>
          <strong>Total Amount: </strong> ₹ ${data.items.reduce((total, item) => total + item.quantity * (item.rate ? item.rate : 0), 0)}<br>
      `,
    })
  }


  useEffect(() => {
    fetchEstimates();
  }, []);
  useEffect(() => {
    fetchItems();
  }, [page, limit, filter, form]);
  const fetchEstimates = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/estimates`, {
        params: { createdBy: user?.user?._id } 
      });
      setEstimates(response.data);
    } catch (error) {
      Swal.fire('Error', 'Failed to fetch estimates', 'error');
    }
  };

  const fetchItems = async () => {
    try {
      const total = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/items/count`, {
        params: { filter },
      });
      setTotalItems(total.data.count)
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/items`, {
        params: { page, limit, filter },
      });
      setItems(response.data);
    } catch (error) {
      Swal.fire('Error', 'Failed to fetch items', 'error');
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleItemChange = (index, field, value) => {
    const newItems = [...form.items];
    newItems[index][field] = value;
    setForm({ ...form, items: newItems });
  };

  // Function to open Item Modal 
  const openItemModal = (func) => {
    // Reset search and pagination
    setFilter('');
    setPage(1);
    
    setModalVisible({ open: true, func });
    fetchItems(); 
  };

  // Function to handle item selection from modal
  const handleItemSelection = (skuCode) => {
    addItem(skuCode); 
    setModalVisible({ open: false, func: null });
  };

  const addItem = (skuCode = '') => {
    const newItems = [...form.items];
    const existingItem = newItems.find((item) => item.skuCode === '');
    if (existingItem) {
      existingItem.skuCode = skuCode;
    } else {
      newItems.push({ skuCode, quantity: 1, rate: 0 });
    }
    setForm({
      ...form,
      items: newItems
    });
  };

  const removeItem = (index) => {
    const newItems = [...form.items];
    newItems.splice(index, 1);
    setForm({ ...form, items: newItems });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.items.length === 0 || form.items.some(item => !item.skuCode)) {
      Swal.fire('Error', 'Please add at least one item with a valid SKU code.', 'error');
      return;
    }

    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/estimates`, form);
      Swal.fire('Success', 'Estimate created successfully', 'success');
      fetchEstimates(); 
      setForm({ 
        name: '',
        items: [{ skuCode: '', quantity: 1, rate: 0 }],
        createdBy: user?.user?._id 
      });
    } catch (error) {
      Swal.fire('Error', 'Failed to create estimate', 'error');
    }
  };

  return (
    <div className="p-6 md:p-12"> 
      <h2 className="text-2xl md:text-3xl font-bold mb-4">Estimate</h2>

      <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="name">
            Issused To
          </label>
          <input 
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" 
            id="name" 
            type="text" 
            name="name" 
            placeholder="Issued To" 
            value={form.name}
            onChange={handleInputChange}
            required 
          />
        </div>

        <div className="mb-4">
          <h3 className="text-lg font-bold mb-2">Items</h3>
          {form.items.map((item, index) => (
            <div key={index} className="flex items-center mb-2">
              <div className="w-1/2 mr-2">
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={`item-skuCode-${index}`}>
                  SKU Code
                </label>
                <div className="relative">
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" 
                  id={`item-skuCode-${index}`} 
                  type="text" 
                  name="skuCode" 
                  placeholder="SKU Code" 
                  value={item.skuCode}
                  onFocus={() => openItemModal((value) => handleItemChange(index, 'skuCode', value))}
                  onChange={(e) => handleItemChange(index, 'skuCode', e.target.value)} 
                  required
                  onClick={() => openItemModal((value) => handleItemChange(index, 'skuCode', value))}
                />
                <button 
                  type="button" 
                  onClick={() => openItemModal((value) => handleItemChange(index, 'skuCode', value))}
                  className="absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 12h-15m0 0l6.75 6.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>

                </button>
              </div>
              </div>
              <div className="w-1/4 mr-2">
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={`item-quantity-${index}`}>
                  Quantity
                </label>
                <input 
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" 
                  id={`item-quantity-${index}`} 
                  type="number" 
                  name="quantity" 
                  value={item.quantity}
                  onChange={(e) => handleItemChange(index, 'quantity', e.target.value)} 
                  min="1" 
                  required 
                />
              </div>
              <div className="w-1/4">
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={`item-rate-${index}`}>
                  Rate
                </label>
                <input 
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" 
                  id={`item-rate-${index}`} 
                  type="number" 
                  name="rate" 
                  value={item.rate}
                  onChange={(e) => handleItemChange(index, 'rate', e.target.value)} 
                  min="0" 
                  required 
                />
              </div>
              <button type="button" onClick={() => removeItem(index)} className="ml-2 px-2 py-1 bg-red-500 text-white font-bold rounded hover:bg-red-700">
                Remove
              </button>
            </div>
          ))}
        </div>
        <div className="flex items-center justify-between">
          <div className="text-lg font-bold">
            Total Amount: {form.items.reduce((total, item) => total + item.quantity * item.rate, 0)}
          </div>
          <button 
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" 
            type="submit"
          >
            Create Estimate
          </button>
        </div>
      </form>
      <div 
        style={{ 
          visibility: ModalVisible.open ? 'visible' : 'hidden', 
          position: 'fixed', 
          top: 0, 
          left: 0, 
          width: '100%', 
          height: '100%', 
          backgroundColor: 'rgba(0, 0, 0, 0.5)', 
          zIndex: 999, 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center' 
        }} 
        className={`${ModalVisible.open ? 'block' : 'hidden'} fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center z-50 w-full max-h-full`}
      >
        <div className="bg-white rounded-lg shadow-lg p-6 max-w-lg w-full" style={{maxHeight: '80vh', overflow: 'auto'}}>
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-xl font-bold">Item Selection</h3>
            <button 
              onClick={() => setModalVisible({ open: false, func: null })} 
              className="text-gray-500 hover:text-gray-800"
            >
              &times;
            </button>
          </div>
          <div className="mb-4">
            <label className="block text-gray-700">Filter Items</label>
            <input
              type="text"
              placeholder="Search items..."
              onChange={(e) => setFilter(e.target.value)}
              className="w-full p-2 border rounded"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700">Limit Items</label>
            <select
              value={limit}
              onChange={(e) => setLimit(parseInt(e.target.value, 10))}
              className="w-full p-2 border rounded"
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
            </select>
          </div>
          <table className="w-full table-auto border-collapse" style={{ border: '1px solid #ccc', maxHeight: '300px', overflowY: 'scroll' }}>
            <thead>
              <tr>
                <th className="border px-4 py-2">Select</th>
                <th className="border px-4 py-2">SKU Code</th>
                <th className="border px-4 py-2">Description</th>
                <th className="border px-4 py-2">MRP</th>
              </tr>
            </thead>
            <tbody>
              {items
                .filter(item => item.skuCode.toLowerCase().includes(filter.toLowerCase()) || item.skuDescription.toLowerCase().includes(filter.toLowerCase())) // Filtering logic
                .slice((page - 1) * limit, page * limit) // Pagination logic
                .map((item, index) => (
                  <tr key={index}>
                    <td className="border px-4 py-2">
                      <button
                        onClick={() => handleItemSelection(item.skuCode)}
                        className="text-blue-500"
                      >
                        Select
                      </button>
                    </td>
                    <td className="border px-4 py-2">{item.skuCode}</td>
                    <td className="border px-4 py-2">{item.skuDescription}</td>
                    <td className="border px-4 py-2">{item.mrp}</td>
                  </tr>
                ))}
            </tbody>
          </table>
          <div className="flex justify-center space-x-2 mt-4 mb-2">
            <button
              onClick={() => setPage(page - 1)}
              disabled={page === 1}
              className="bg-blue-500 text-white px-3 py-1 rounded-full shadow hover:bg-blue-600 disabled:opacity-50"
            >
              Previous
            </button>
            {[page - 1, page, page + 1].map((index) =>
              index >= 1 && index <= totalPages ? (
                <button
                  key={index}
                  onClick={() => setPage(index)}
                  disabled={page === index}
                  className={`px-3 py-1 rounded-full shadow ${
                    page === index ? 'bg-blue-700 text-white' : 'bg-white text-blue-500 hover:bg-blue-100'
                  }`}
                >
                  {index}
                </button>
              ) : null
            )}
            <button
              onClick={() => setPage(page + 1)}
              disabled={page === totalPages}
              className="bg-blue-500 text-white px-3 py-1 rounded-full shadow hover:bg-blue-600 disabled:opacity-50"
            >
              Next
            </button>
          </div>
          <p className="text-center text-gray-600 mt-2">
            Showing {(page - 1) * limit + 1} to {Math.min(page * limit, totalItems)} of {totalItems} entries
          </p>
        </div>
      </div>
      {/* Estimate Listing */}
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Item Count</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total Amount</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Action</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {estimates.map(estimate => (
            <tr key={estimate._id}>
              <td className="px-6 py-4 whitespace-nowrap">{estimate.id}</td>
              <td className="px-6 py-4 whitespace-nowrap">{estimate.name}</td>
              <td className="px-6 py-4 whitespace-nowrap">
                {estimate.items.length}
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                {estimate.items.reduce((total, item) => total + item.quantity * item.rate, 0)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                  estimate.status === 'Approved' ? 'bg-green-100 text-green-800' : 
                  estimate.status === 'Rejected' ? 'bg-red-100 text-red-800' : 
                  'bg-yellow-100 text-yellow-800'
                }`}>
                  {estimate.status}
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <button
                  onClick={() => handleView(estimate)}
                  className="text-blue-500 hover:text-blue-700"
                >
                  View
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Estimate;